import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';


class EquipmentResources extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>My Equipment:</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default EquipmentResources



// WEBPACK FOOTER //
// src/Resources/EquipmentResources.js